import PropTypes from 'prop-types'
import useCMSEntries from './hooks/useCMSEntries'

CMSEntries.propTypes = {
  contentType: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  sortField: PropTypes.string,
  filters: PropTypes.object,
  fallbackFilters: PropTypes.object,
  renderWhenLoading: PropTypes.bool
}

export default function CMSEntries({
  contentType,
  children,
  filters = {},
  fallbackFilters = null,
  sortField,
  renderWhenLoading = false
}) {
  const entries = useCMSEntries({ contentType, sortField, filters })
  const fallbackEntries = useCMSEntries({
    contentType,
    sortField,
    filters: fallbackFilters,
    skip: !fallbackFilters || !entries || entries.length
  })

  if (fallbackEntries) {
    return children(fallbackEntries)
  } else if (entries) {
    return children(entries)
  } else {
    return renderWhenLoading ? children(null) : null
  }
}

export { CMSEntries }
